<template>
  <div class="news-detail-page container">
    <div class="back-btns fs" @click="back">
      <img :src="backIco">
      <span>{{ $t('newsCenterPage.back') }}</span>
    </div>
    <h1>{{ newsDetail.title }}</h1>
    <div class="public_date">{{ newsDetail.subTitle }}</div>
    <div class="news-content" v-html="newsDetail.content">
    </div>
  </div>
</template>

<script setup>
import newsData from '@/assets/json/news'
import { useRouter, useRoute } from 'vue-router';
const { query } = useRoute();
console.log(useRoute(), '++++++')
const newsDetail = newsData[query.id];
const router = useRouter();
const backIco = require('@assets/icons/ico-back.svg')
const back = () => {
  router.go(-1);
}
</script>

<style lang="less" scoped>
.news-detail-page {
  width: 100%;
  padding-top: 90px;
  margin-bottom: 415px;
  .back-btns {
    font-size: 18px;
    line-height: 42px;
    cursor: pointer;
    color: rgba(0, 0, 0, 1);
    span {
      margin-left: 7px;
    }
  }
  h1 {
    margin: 30px auto 24px auto;
    color: #151E2C;
    font-size: 30px;
    font-weight: 600;
    line-height: 60px; /* 200% */
  }
  .public_date {
    color: #9A9A9A;
    font-size: 16px;
    line-height: 16px; /* 100% */
  }
  .news-content {
    margin-top: 73px;
    color: #3A3A3A;
    font-size: 14px;
    line-height: 28px; /* 200% */
    p {
      width: 100%;
      margin-bottom: 31px;
      img {
        max-width: 590px;
      }
    }
  }
}
</style>